export { default } from "./CreateRole";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/CreateProcRole/index.js